import PropTypes from 'prop-types';
import styled from 'styled-components';

const Spacer = styled.div`
  height: ${p => p.multiplier * p.theme.spacing.unit}px;
`;

Spacer.displayName = 'Spacer';

Spacer.defaultProps = {
  multiplier: 2,
};

Spacer.propTypes = {
  multiplier: PropTypes.number,
};

export default Spacer;
